import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/tabs/style";
import _Tabs from "antd/lib/tabs"; /*@客户-设备流量*/
import React from 'react';
import * as echarts from "echarts";
import { withRouter } from "react-router-dom";
import { addComma, parse } from "../../../../../utils/commonUtilFunc";
import { connect } from "dva";
import { chartColor, pieChartColor } from "../../../../../utils/commonConsts";
import UserFlowRankTab from "../AppRankSubs/UserFlowRankTab";
import DayFlowChart from "../AppRankSubs/DayFlowChart";
import { injectIntl } from "react-intl";
import DesIpFlowChart from "../AppRankSubs/DesIpFlowChart";
var TabPane = _Tabs.TabPane;
var AppFlowDetailInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(AppFlowDetailInfo, _React$Component);
  function AppFlowDetailInfo(props) {
    var _this;
    _classCallCheck(this, AppFlowDetailInfo);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppFlowDetailInfo).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCloseAppFlowDetailModal", function () {
      _this.setState({
        ifAppFlowDetailModalShow: false,
        selectedAppId: "",
        selectedAppNm: "",
        selectedAppFlow: "0"
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderChart", function (el) {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '5%',
          right: '6%',
          bottom: '10%',
          top: "5%",
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,0.45)"
            }
          },
          name: "MB"
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(0,0,0,0.45)"
            }
          },
          inverse: true
        },
        series: [{
          name: "flow",
          type: 'bar',
          data: _this.props.ci0303Info.step_apps_flow,
          itemStyle: {
            normal: {
              color: function color(params) {
                return pieChartColor[params.dataIndex % chartColor.length];
              }
            }
          },
          label: {
            normal: {
              show: true,
              position: 'right'
            }
          },
          barCategoryGap: "60%",
          barMinHeight: "10",
          barMaxWidth: 32
        }],
        color: ["red", "yellow"]
      };
      el.setOption(option);
    });
    _this.state = {
      ifAppFlowDetailModalShow: false,
      selectedAppId: "",
      selectedAppNm: "",
      selectedAppFlow: "0"
    };
    var search = parse(_this.props.location.search);
    _this.sn = search.sn;
    _this.start_tm = search.start_tm;
    _this.end_tm = search.end_tm;
    _this.tunnel_dir = search.tunnel_dir;
    _this.tunnel_dir_id = search.tunnel_dir_id;
    return _this;
  }
  _createClass(AppFlowDetailInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var vm = this;
      this.element = echarts.init(document.getElementById('app-flow-detail-chart'));
      this.element.on('click', function (params) {
        vm.setState({
          ifAppFlowDetailModalShow: true,
          selectedAppNm: params.data[3],
          selectedAppId: params.data[2],
          selectedAppFlow: params.data[0]
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderChart(this.element);
    }
  }, {
    key: "render",
    value: function render() {
      var search = parse(this.props.location.search);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        id: "app-flow-detail-chart",
        style: {
          width: 900,
          height: 400
        }
      }), /*#__PURE__*/React.createElement(_Modal, {
        title: "Application traffic details",
        footer: null,
        visible: this.state.ifAppFlowDetailModalShow,
        width: 925,
        onCancel: this.handleCloseAppFlowDetailModal,
        destroyOnClose: true
      }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
        className: "title-device-name"
      }, "apply name", ":", this.state.selectedAppNm), /*#__PURE__*/React.createElement("div", {
        className: "title-device-info"
      }, /*#__PURE__*/React.createElement("span", null, "time slot", ":\xA0\xA0", search.start_tm, "\xA0", "to", "\xA0", search.end_tm), /*#__PURE__*/React.createElement("span", null, "Traffic type", ":\xA0\xA0", search.tunnel_dir), /*#__PURE__*/React.createElement("span", null, "Traffic size", ":\xA0", addComma(this.state.selectedAppFlow), "\xA0\xA0MB"))), /*#__PURE__*/React.createElement(_Tabs, null, /*#__PURE__*/React.createElement(TabPane, {
        tab: "User Ranking",
        key: "1"
      }, /*#__PURE__*/React.createElement(UserFlowRankTab, {
        ids: this.state.selectedAppId,
        flow: this.state.selectedAppFlow
      })), /*#__PURE__*/React.createElement(TabPane, {
        tab: "Daily flow trend chart",
        key: "2"
      }, /*#__PURE__*/React.createElement(DayFlowChart, {
        ids: this.state.selectedAppId
      })), /*#__PURE__*/React.createElement(TabPane, {
        tab: "Target IP traffic",
        key: "3"
      }, /*#__PURE__*/React.createElement(DesIpFlowChart, {
        ids: this.state.selectedAppId,
        flow: this.state.selectedAppFlow
      })))));
    }
  }]);
  return AppFlowDetailInfo;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0303Info = _ref.ci0303Info;
  return {
    ci0303Info: ci0303Info
  };
}
export default connect(mapDispatchToProps)(withRouter(injectIntl(AppFlowDetailInfo)));